import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Link, TrendingUp } from 'lucide-react';
export function PhasesSection() {
  const phases = [{
    id: '01',
    title: 'Activación Emocional',
    description: 'Aprendé a generar interés genuino desde el primer momento. Sin frases. Sin actuación.',
    icon: Zap
  }, {
    id: '02',
    title: 'Conexión Segura',
    description: 'Construí una conexión real que no dependa de agradar. Basada en autenticidad y presencia.',
    icon: Link
  }, {
    id: '03',
    title: 'Escalada Natural',
    description: 'Llevá la interacción al siguiente nivel de forma orgánica, sin forzar ni adivinar.',
    icon: TrendingUp
  }];
  return <section className="py-32 bg-secondary" data-id="element-129">
      <div className="max-w-7xl mx-auto px-6" data-id="element-130">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-4xl font-bold text-white mb-20 text-center" data-id="element-131">
          Las 3 fases del sistema
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-132">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-gold/30 to-transparent -z-10" data-id="element-133" />

          {phases.map((phase, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-tertiary p-8 rounded-lg border border-white/5 hover:border-gold/30 transition-all duration-300 group relative overflow-hidden" data-id="element-134">
              <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-135">
                <phase.icon size={120} className="text-gold" data-id="element-136" />
              </div>

              <div className="text-6xl font-black text-transparent bg-clip-text bg-gradient-to-b from-gold/40 to-transparent mb-6" data-id="element-137">
                {phase.id}
              </div>

              <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-gold transition-colors" data-id="element-138">
                {phase.title}
              </h3>

              <p className="text-gray-400 leading-relaxed relative z-10" data-id="element-139">
                {phase.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}